import { useTranslation } from 'react-i18next';
import { useUrlLocale } from '@/hooks/useUrlLocale';

export const useHomeNavigationItem = () => {
  const { t } = useTranslation('navigation');
  const locale = useUrlLocale();

  return {
    id: 'home',
    icon: 'Home' as const,
    path: `/${locale}/home`,
    label: t('crossPlatform.primary.home'),
  };
};
